import { createSelector } from "@reduxjs/toolkit";
import { SocialVisibility } from "Services/API/API";

export const socialVisibilitySelector = createSelector<[(state: LSStore.State) => LSCommon.Models.UserJsModel], SocialVisibility>((state) => state.user.value, user => user.socialVisibility);
